import { useProgress } from "./progress";

interface ReloadStore {
  getState: () => {
    persistence: "ready" | "protected" | "unavailable";
    saveState: "saved" | "saving" | "error";
    flush: () => Promise<void>;
  };
}

/** Never refresh away protected, unavailable, failed, or newly unsaved data. */
export async function saveBeforeReload(store: ReloadStore = useProgress) {
  if (store.getState().persistence !== "ready") return false;
  try {
    await store.getState().flush();
    const state = store.getState();
    return state.persistence === "ready" && state.saveState === "saved";
  } catch {
    return false;
  }
}
